import React, { useState } from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";
import { Textarea } from "@windmill/react-ui";

const CancelModal = ({ isOpen, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const handleConfirm = () => {
    onConfirm(reason);
    setReason("");
  };
  return (
    <Modal
    className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
      isOpen={isOpen}
      onClose={() => {
        setReason("");
        onClose();
      }}
    >
      <ModalBody className="custom-modal">
        <p>Are you sure to Cancel this Booking?</p>
        <div className="flex  mt-4">
          <Textarea
            className="focus:shadow-none border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
            placeholder="Enter Cancel Reason (Minimum 10 characters)"
            rows="4"
            style={{ minHeight: "100px", maxHeight: "300px" }}
            onChange={(e) => {
              setReason(e.target.value);
            }}
          />
        </div>
        <div className="flex justify-end mt-4">
          <Button
            layout="outline"
            onClick={() => {
              onClose();
              setReason("");
            }}
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          >
            No
          </Button>
          <Button onClick={handleConfirm} disabled={reason.length < 10}>
            Yes
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CancelModal;
